// Import dependencies
import React, { useEffect } from "react";
import * as notif_helpers from '../../../helpers/Notifications.js';

// Import CSS & Assets
import './ErrorPage.css';
import oups from '../../../assets/oups.svg'

const ErrorPage = ({ setIsError, errorMsg, errorLogs, version }) => {

    function prepareEmail(error_data) {
        var subject = "Remontée de bug sur Proplab";
        var body = "Données concernant l'erreur:\r\n\r\nURL = " + window.location.href + "\r\nLOGS = " + error_data.toString();
        var uri = "mailto:hello@proplab.fr?subject=";
        uri += encodeURIComponent(subject);
        uri += "&body=";
        uri += encodeURIComponent(body);
        window.open(uri);
    }



    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('profile'));
        const url = window.location.href;
        const capa_id = url.substring(url.indexOf("capastudy/") + 10);
        console.log("ERROR PAGE", errorMsg);
        // Send admin notification
        notif_helpers.sendPushoverNotification("Proplab - Erreur", "Détails de l'erreur :\nID de l'étude : " + capa_id + "\nUtilisateur : " + user?.result?.email + "\nErrorMsg : " + errorMsg + "\nLogs :\n" + errorLogs, window.location.href, "Ouvrir la page");
    }, []);


    return (
        <div className="error__container">
            <div className="error__content_container">
                {/* <div className="error__content_title">OUPS !</div> */}
                <img className="error__content_title_img" src={oups} alt="" />
                <div className="error__content_subtitle">Une erreur est survenue</div>
                <div className="error__content_text">Notre application est en version bêta, nous travaillons activement pour corriger les derniers bugs 💪<br></br>N'hésitez pas à contacter notre équipe sur <span className="error__link" onClick={() => { prepareEmail(errorMsg) }}>hello@proplab.fr</span> si le problème persiste.</div>
                {/* <div className="error__content_text">{errorMsg}</div> */}
                <div className="error__content_button_container">
                    <div className="error__content_button" onClick={() => { window.location.reload(false); }}>Recharger la page</div>
                    <div className="error__content_button" onClick={() => { window.location.href = "/dashboard"; }}>Retourner au Dashboard</div>
                </div>
            </div>
            <div className="error__version" onClick={() => { setIsError(false) }}>{version}</div>
        </div>
    );
};

export default ErrorPage;